import type { StatusColorName } from "@kontextwerk/web-sdk/core/display/status"
import {
  formatWorkOrderTypeTagLabel,
  resolveOrderTypeColor,
} from "../../../../../_shared/_logic/order-type-tags"
import { buildOrderSummaryTooltip } from "../../../../../_shared/_logic/order-summary-tooltip"
import {
  internalOrderTypeLabel,
  internalOrderTypeLabels,
} from "../../../../../_shared/_logic/order-type-labels"
import { parseDateOnly } from "../../../../_shared/_logic/timezones"

type AppointmentContactSummary = {
  contactName?: string | null
  contactPhone?: string | null
  contactEmail?: string | null
}

export type WorkOrderSummaryTagPresentation = {
  label: string
  subLabel: string
  color: StatusColorName | string
  numberLabel: string
  fullLabel: string
  tooltip: string
  sortLabel: string
  dueLabel: string
}

export const formatWorkOrderDueDate = (value: string | null | undefined) => {
  const parsed = parseDateOnly(value)

  if (!parsed) return "–"

  return parsed.toLocaleDateString("de-DE")
}

export const buildWorkOrderSummaryTagPresentation = ({
  workOrder,
  color,
  dueStatusDescription,
  appointmentLabel,
  employeeLabel,
  appointmentContact,
}: {
  workOrder?: WorkOrder | null
  color?: StatusColorName | string | null
  dueStatusDescription?: string | null
  appointmentLabel?: string | null
  employeeLabel?: string | null
  appointmentContact?: AppointmentContactSummary | null
}): WorkOrderSummaryTagPresentation => {
  const orderTypeTitle = internalOrderTypeLabel(workOrder)
  const fullLabel = orderTypeTitle || "Ohne Typ"
  const label = formatWorkOrderTypeTagLabel(workOrder)
  const numberLabel = `${workOrder?.order_number ?? ""}`.trim() || "–"
  const dueLabel = formatWorkOrderDueDate(workOrder?.due_date)
  const resolvedColor = color || resolveOrderTypeColor(orderTypeTitle)

  return {
    label,
    subLabel: `fällig: ${dueLabel}`,
    color: resolvedColor,
    numberLabel,
    fullLabel,
    sortLabel: `${label} ${numberLabel}`.trim(),
    dueLabel,
    tooltip: buildOrderSummaryTooltip({
      orderNumberLabel: numberLabel,
      orderTypeLabels: internalOrderTypeLabels(workOrder),
      visibleOrderTypeLabel: label,
      dueLabel,
      dueStatus: dueStatusDescription,
      appointmentLabel,
      employeeLabel,
      appointmentContact,
    }),
  }
}
